
import { css } from 'lit';
export default css`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
  font-family: var(--ff-display);
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
/* unset browser defaults for headings and p */
:host:is(h1,h2,h3,h4,h5,h6,p),
h1,h2,h3,h4,h5,h6 {
  all: unset;
}
/* Image reset */
img {
  max-width: 100%;
}
/* Apply proper CSS for accessibly hiding elements to each component. */
.sr-only,
.visually-hidden {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
/* Apply component specific CSS */
:host{
  --layout-gap:var(
    --sic-carousel-block--layout-gap,
    var(--sic-carousel-block--default--layout-gap)
  );
}

.carousel-block{
  display:flex;
  flex-direction:column;
  grid-row-gap:var(--spacing-8);
}

@media (min-width: 1024px){

.carousel-block{
    display:grid;
    grid-template-columns:calc(1 / 3 * calc(100% - var(--layout-gap))) calc(
        2 / 3 * calc(100% - var(--layout-gap))
      );
    grid-template-rows:1fr;
    grid-column-gap:var(--layout-gap);
    grid-row-gap:0px
}
  }

.intro{
  display:flex;
  flex-direction:column;
  gap:var(--spacing-05);
}

.description{
  font-size:var(--sic-carousel-block--default--font-size);
  font-size:var(
    --sic-carousel--font-size,
    var(--sic-carousel-block--default--font-size)
  );
  line-height:var(--sic-carousel-block--default--line-height);
  line-height:var(
    --sic-carousel--line-height,
    var(--sic-carousel-block--default--line-height)
  );
  color:var(--color-neutral-default);
}

@media (min-width: 1024px){

.intro{
    padding-bottom:0;
    padding-top:3.75rem
}
  }

.cta{
  margin-top:var(--spacing-02);
}
`;